var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script',{tag:"component",attrs:{"type":"application/ld+json"},domProps:{"innerHTML":_vm._s(_vm.jsonld)}})}]

export { render, staticRenderFns }